module.exports = __webpack_public_path__ + "static/media/large.221b6df2.png";